import { useTranslation } from 'react-i18next';

import { LoadingSpinner } from 'components/Loading/LoadingSpinner';

export const LoadingErrors = () => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-1">
      <LoadingSpinner variant="error" sizeClassName="size-5" />
      <span className="text-xs font-medium text-red-700">
        {t('webedi:viewDocument.messageErrorBanner.loadingDatachecks.calculatingAffectedFields')}
      </span>
    </div>
  );
};
